import React from 'react';
import { Modal, Button, Form } from 'react-bootstrap';

const FormModal = ({
    show,
    onHide,
    title,
    onSubmit,
    children,
    submitText = "Submit",
    cancelText = "Cancel",
    submitVariant = "primary",
    isSubmitting = false,
    size = "lg"
}) => {
    return (
        <Modal show={show} onHide={onHide} size={size} centered>
            <Form onSubmit={onSubmit}>
                <Modal.Header closeButton>
                    <Modal.Title>{title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {children}
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="outline-secondary"
                        onClick={onHide}
                        disabled={isSubmitting}
                    >
                        {cancelText}
                    </Button>
                    <Button
                        variant={submitVariant}
                        type="submit"
                        disabled={isSubmitting}
                    >
                        {isSubmitting ? (
                            <>
                                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                Processing...
                            </>
                        ) : (
                            submitText
                        )}
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
};

export default FormModal;